export enum SelectCarrierStatusId {
  New = 1,
  Contacted = 2,
  NotInterested = 3,
  Pending = 4,
  Confirmed = 5,
  Removed = 6,
}
